module.exports = __webpack_public_path__ + "static/media/home-img-nl.4b8aec94.svg";